import { defineStore } from "pinia";

export const useIdxDBStore = defineStore('idxDB', {
    state: () => {
        return {

        }
    },  
    actions: {         
      save(storeName, object){
          return new Promise(
            function(resolve, reject) {
              const instance = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
              
              if (!instance) {                
                reject("IndexedDB could not be found in this browser.");
              }

              let request =  instance.open("DB", 1);
        
              request.onerror = function() {
                reject(Error("Erro no IndexedDB"));
              };
        
              request.onupgradeneeded = function() {
                const db = request.result;                
                db.createObjectStore(storeName, { keyPath: "id" });
              };
        
              request.onsuccess = function() {                
                const db = request.result;                
                const transaction = db.transaction(storeName, "readwrite");                
                const store = transaction.objectStore(storeName);                                                
                store.put(object);                
                transaction.oncomplete = function () {
                  db.close();
                  resolve("Finalizado!")
                };
              };
            }
          );
      },
      list(storeName){
          return new Promise(
            function(resolve, reject) {
              const instance = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
              
              if (!instance) {                
                reject("IndexedDB could not be found in this browser.");
              }

              let request =  instance.open("DB", 1);
        
              request.onerror = function() {
                reject(Error("Erro no IndexedDB"));
              };
        
              request.onupgradeneeded = function() {
                const db = request.result;                
                db.createObjectStore(storeName, { keyPath: "id" });
              };
        
              request.onsuccess = function() {                
                const db = request.result;                
                const transaction = db.transaction(storeName, "readwrite");                
                const store = transaction.objectStore(storeName);                                                                                
                const query = store.getAll();                                
                query.onsuccess = function () {
                  db.close();
                  resolve(query.result);
                };                                                              
              };
            }
          );
      },
      remove(storeName, id){
          return new Promise(
            function(resolve, reject) {             
              const instance = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
              
              if (!instance) {                
                reject("IndexedDB could not be found in this browser.");
              }

              let request =  instance.open("DB", 1);
        
              request.onerror = function() {
                reject(Error("Erro no IndexedDB"));
              };
        
              request.onupgradeneeded = function() {
                const db = request.result;                
                db.createObjectStore(storeName, { keyPath: "id" });
              };
        
              request.onsuccess = function() {                
                const db = request.result;                
                const transaction = db.transaction(storeName, "readwrite");                
                const store = transaction.objectStore(storeName);                                                
                store.delete(id); 
                
                store.onsuccess = function() {
                  db.close();                  
                  resolve("Finalizado");
                }                                                
              };              
            }
          );
      },

    }
})
